import { render } from "./BaseComponent.vue?vue&type=template&id=fb9c30a6"
import script from "./BaseComponent.vue?vue&type=script&lang=js"
export * from "./BaseComponent.vue?vue&type=script&lang=js"

import "./BaseComponent.vue?vue&type=style&index=0&id=fb9c30a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__